import { SET_EXTERNAL_USERS_SHARE_DIALOG_OPEN, SET_SHARE_ITEM_DATA } from "redux/constants/portal";

const initialState = {
  isExternalUsersShareDialogOpen: false,
  shareUserEmails: [],
  shareItemData: {
    item: null,
    item_id: null,
    item_name: null,
    item_tenant_id: null,
    item_owner_id: null,
  },
};

const sharing = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_EXTERNAL_USERS_SHARE_DIALOG_OPEN:
      return {
        ...state,
        isExternalUsersShareDialogOpen: payload,
      };
    case SET_SHARE_ITEM_DATA:
      return {
        ...state,
        shareItemData: payload,
      };
  }
  return state;
};

export default sharing;
